import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FooterLogoAddressComponent } from '../footer-logo-address/footer-logo-address.component';

@Component({
  selector: 'dskhome-footer-logo',
  templateUrl: './footer-logo.component.html',
  styleUrls: ['./footer-logo.component.scss'],
  imports: [MatIcon, FooterLogoAddressComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterLogoComponent {
  readonly copyrightYear = new Date().getFullYear();
}
